import { GridRowId } from '@mui/x-data-grid';

import NetZeroDeleteButton from './NetZeroDeleteButton';
import NetZeroEditButton from './NetZeroEditButton';

export type NetZeroActionsProps = {
  rowId: GridRowId;
};

const NetZeroActions = ({ rowId }: NetZeroActionsProps) => {
  return (
    <>
      <NetZeroEditButton rowId={rowId} />
      <NetZeroDeleteButton rowId={rowId} />
    </>
  );
};

export default NetZeroActions;
